(() => {
  window.SBHeaderInitializers = window.SBHeaderInitializers || [];

  window.SBHeaderInitializers.push((context) => {
    const { header, signal, findHeaderRef, addRuntimeEventListener, onAbort, shared } = context;

    const mobileMenuDrawer = findHeaderRef(document, 'headerDrawerContainer', '[data-mobile-menu-drawer]');
    const mobileMenuToggle = header.querySelector('[data-mobile-menu-toggle]');
    const mobileMenuPanel = mobileMenuDrawer?.querySelector('[data-mobile-menu-panel]');
    const mobileMenuCloseControls = mobileMenuDrawer
      ? mobileMenuDrawer.querySelectorAll('[data-mobile-menu-close]')
      : [];
    const mobileMenuReview = mobileMenuDrawer
      ? mobileMenuDrawer.querySelector('[data-mobile-menu-review]')
      : null;
    const mobileMenuReviewName = mobileMenuReview
      ? mobileMenuReview.querySelector('[data-mobile-menu-review-name]')
      : null;
    const mobileMenuReviewText = mobileMenuReview
      ? mobileMenuReview.querySelector('[data-mobile-menu-review-text]')
      : null;
    const mobileMenuReviewDate = mobileMenuReview
      ? mobileMenuReview.querySelector('[data-mobile-menu-review-date]')
      : null;
    const mobileMenuReviewStars = mobileMenuReview
      ? mobileMenuReview.querySelector('[data-mobile-menu-review-stars]')
      : null;
    const mobileMenuReviewTranslation = mobileMenuReview
      ? mobileMenuReview.querySelector('[data-mobile-menu-review-translation]')
      : null;
    const mobileMenuReviewTranslationStatus = mobileMenuReview
      ? mobileMenuReview.querySelector('[data-mobile-menu-review-translation-status]')
      : null;
    const mobileMenuReviewCountryStatus = mobileMenuReview
      ? mobileMenuReview.querySelector('[data-mobile-menu-review-country-status]')
      : null;
    const mobileMenuReviewCountrySeparator = mobileMenuReview
      ? mobileMenuReview.querySelector('[data-mobile-menu-review-country-separator]')
      : null;
    const mobileMenuReviewTranslationSeparator = mobileMenuReview
      ? mobileMenuReview.querySelector('[data-mobile-menu-review-translation-separator]')
      : null;
    const mobileMenuReviewTranslationToggle = mobileMenuReview
      ? mobileMenuReview.querySelector('[data-mobile-menu-review-translation-toggle]')
      : null;
    const mobileMenuReviewProductCard = mobileMenuReview
      ? mobileMenuReview.querySelector('[data-mobile-menu-review-product-card]')
      : null;
    const mobileMenuReviewProductMedia = mobileMenuReviewProductCard
      ? mobileMenuReviewProductCard.querySelector('[data-mobile-menu-review-product-media]')
      : null;
    const mobileMenuReviewProductImage = mobileMenuReviewProductCard
      ? mobileMenuReviewProductCard.querySelector('[data-mobile-menu-review-product-image]')
      : null;
    const mobileMenuReviewProductTitle = mobileMenuReviewProductCard
      ? mobileMenuReviewProductCard.querySelector('[data-mobile-menu-review-product-title]')
      : null;
    const mobileMenuReviewProductRating = mobileMenuReviewProductCard
      ? mobileMenuReviewProductCard.querySelector('[data-mobile-menu-review-product-rating]')
      : null;
    const mobileMenuReviewProductCount = mobileMenuReviewProductCard
      ? mobileMenuReviewProductCard.querySelector('[data-mobile-menu-review-product-count]')
      : null;
    const mobileMenuTrustpilot = mobileMenuDrawer
      ? mobileMenuDrawer.querySelector('.menu-drawer__trustpilot')
      : null;

    const mobileMenuReviewStorageKey = 'sb-mobile-menu-review-id';
    let mobileMenuReviews = [];
    let activeMobileMenuReview = null;
    let showOriginalMobileMenuReview = false;
    let mobileMenuReviewsRequest = null;
    const mobileMenuReviewProductMetaCache = new Map();

    let pageScrollLockY = 0;
    let pageScrollLockMode = null;

    const supportsDesktopHoverNavigation = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const isDesktopViewport = () => window.matchMedia('(min-width: 990px)').matches && supportsDesktopHoverNavigation();
    const isMobileViewport = () => !isDesktopViewport();
    const isMobileMenuOpen = () => Boolean(mobileMenuDrawer && mobileMenuDrawer.classList.contains('menu-open'));

    shared.isDesktopViewport = isDesktopViewport;
    shared.isMobileViewport = isMobileViewport;
    shared.isMobileMenuOpen = isMobileMenuOpen;
    shared.getScrollLockY = () => pageScrollLockY;
    shared.isScrollLocked = () => document.body.dataset.sbScrollLocked === 'true';

    const setStickyLastY = (value) => {
      if (typeof shared.setStickyLastY === 'function') {
        shared.setStickyLastY(value);
      }
    };

    const closeAllMobileAccordions = () => {
      if (!mobileMenuDrawer) return;
      mobileMenuDrawer.querySelectorAll('.menu-drawer__menu-container[open]').forEach((accordion) => {
        accordion.removeAttribute('open');
      });
      mobileMenuDrawer.querySelectorAll('drawer-localization-component').forEach((component) => {
        if (typeof component.closeDrawerPage === 'function') {
          component.closeDrawerPage({ immediate: true });
          return;
        }
        component.classList.remove('menu-open');
        const menuDrawerElement = component.closest('.menu-drawer');
        if (menuDrawerElement) menuDrawerElement.classList.remove('menu-drawer--has-submenu-opened');
        const panel = component.querySelector('[data-localization-ref="drawerPage"]');
        if (panel) panel.hidden = true;
      });
    };

    const shouldSkipDeferredImagePreload = () => {
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!connection) return false;
      if (connection.saveData) return true;
      const effectiveType = `${connection.effectiveType || ''}`.toLowerCase();
      return effectiveType.includes('2g');
    };

    const preloadMobileMenuImages = () => {
      if (signal.aborted || !mobileMenuDrawer || isDesktopViewport() || shouldSkipDeferredImagePreload()) return;
      const imageNodes = mobileMenuDrawer.querySelectorAll('.menu-drawer__submenu-image');
      imageNodes.forEach((imageNode) => {
        if (imageNode.fetchPriority !== 'high') imageNode.fetchPriority = 'low';
        imageNode.loading = 'eager';
      });
    };

    const scheduleMobileMenuPreload = () => {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => preloadMobileMenuImages(), { timeout: 1200 });
        return;
      }
      window.setTimeout(preloadMobileMenuImages, 180);
    };

    const preloadPrimaryMenuImages = (scope = header, { highPriority = false } = {}) => {
      if (signal.aborted || !isDesktopViewport()) return;
      if (!highPriority && shouldSkipDeferredImagePreload()) return;
      const primaryImageNodes = highPriority
        ? scope.querySelectorAll('.header__primary-menu img')
        : scope.querySelectorAll('.header__primary-card-image');
      primaryImageNodes.forEach((imageNode) => {
        if (highPriority) imageNode.fetchPriority = 'high';
        else if (imageNode.fetchPriority !== 'high') imageNode.fetchPriority = 'low';
        imageNode.loading = 'eager';
      });
    };

    const schedulePrimaryMenuPreload = () => {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => preloadPrimaryMenuImages(), { timeout: 1200 });
        return;
      }
      window.setTimeout(preloadPrimaryMenuImages, 180);
    };

    shared.schedulePrimaryMenuPreload = schedulePrimaryMenuPreload;
    shared.preloadPrimaryMenuImages = preloadPrimaryMenuImages;

    const updateMobileMenuTrustpilotLayout = () => {
      if (signal.aborted || !mobileMenuTrustpilot) return;
      mobileMenuTrustpilot.classList.remove('is-stacked');
      if (isDesktopViewport()) return;

      const trustpilotLinks = Array.from(mobileMenuTrustpilot.querySelectorAll('.menu-drawer__trustpilot-link'));
      if (trustpilotLinks.length <= 1) return;

      const trustpilotStyles = window.getComputedStyle(mobileMenuTrustpilot);
      const trustpilotGapValue = parseFloat(trustpilotStyles.columnGap || trustpilotStyles.gap || '0') || 0;
      const totalLinksWidth = trustpilotLinks.reduce((sum, linkElement) => sum + linkElement.getBoundingClientRect().width, 0);
      const requiredWidth = totalLinksWidth + trustpilotGapValue * (trustpilotLinks.length - 1);
      const availableWidth = Math.max(0, mobileMenuTrustpilot.clientWidth - 32);
      if (requiredWidth > availableWidth) mobileMenuTrustpilot.classList.add('is-stacked');
    };

    const reviewLocale = mobileMenuReview?.dataset.mobileMenuReviewLocale || document.documentElement.lang || 'en';
    const reviewLocaleBase = String(reviewLocale).toLowerCase().split('-')[0];
    const reviewRelativeTimeFormat = new Intl.RelativeTimeFormat(reviewLocale, { numeric: 'auto' });
    const reviewDateFormat = new Intl.DateTimeFormat(reviewLocale, { year: 'numeric', month: 'short', day: 'numeric' });
    const reviewNumberFormat = new Intl.NumberFormat(reviewLocale);
    const reviewProductRatingFormat = new Intl.NumberFormat(reviewLocale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const reviewLanguageNames = typeof Intl.DisplayNames === 'function'
      ? new Intl.DisplayNames([reviewLocale], { type: 'language' })
      : null;
    const reviewRegionNames = typeof Intl.DisplayNames === 'function'
      ? new Intl.DisplayNames([reviewLocale], { type: 'region' })
      : null;

    const normalizeLanguageCode = (value) => String(value || '').trim().toLowerCase().replace('_', '-');
    const getReviewSourceLanguage = (review) => normalizeLanguageCode(review?.translation?.source_language);
    const capitalizeReviewDate = (value) => {
      const text = String(value || '');
      return text ? text.charAt(0).toLocaleUpperCase(reviewLocale) + text.slice(1) : '';
    };
    const formatReviewDate = (isoDate) => {
      const timestamp = new Date(isoDate).getTime();
      if (!Number.isFinite(timestamp)) return '';
      const elapsedSeconds = Math.max(0, (Date.now() - timestamp) / 1000);
      if (elapsedSeconds < 3600) {
        return capitalizeReviewDate(reviewRelativeTimeFormat.format(-Math.max(1, Math.round(elapsedSeconds / 60)), 'minute'));
      }
      if (elapsedSeconds < 86400) {
        return capitalizeReviewDate(reviewRelativeTimeFormat.format(-Math.round(elapsedSeconds / 3600), 'hour'));
      }
      if (elapsedSeconds < 604800) {
        return capitalizeReviewDate(reviewRelativeTimeFormat.format(-Math.round(elapsedSeconds / 86400), 'day'));
      }
      if (elapsedSeconds < 86400 * 35) {
        return capitalizeReviewDate(reviewRelativeTimeFormat.format(-Math.round(elapsedSeconds / 604800), 'week'));
      }
      if (elapsedSeconds < 86400 * 365) {
        return capitalizeReviewDate(reviewRelativeTimeFormat.format(-Math.round(elapsedSeconds / (86400 * 30.44)), 'month'));
      }
      return reviewDateFormat.format(timestamp);
    };
    const reviewLanguageName = (code) => {
      try {
        return reviewLanguageNames?.of(code) || code;
      } catch (_) {
        return code;
      }
    };
    const reviewCountryName = (review) => {
      const suppliedName = String(review?.reviewer_country || '').trim();
      const code = String(review?.reviewer_country_code || '').trim().toUpperCase();
      if (/^[A-Z]{2}$/.test(code)) {
        try {
          return reviewRegionNames?.of(code) || suppliedName || code;
        } catch (_) {
          return suppliedName || code;
        }
      }
      return suppliedName;
    };

    const getStoredReviewId = () => {
      try {
        const storedValue = sessionStorage.getItem(mobileMenuReviewStorageKey);
        return String(storedValue || '');
      } catch (_) {
        return '';
      }
    };

    const storeReviewId = (reviewId) => {
      try {
        sessionStorage.setItem(mobileMenuReviewStorageKey, `${reviewId}`);
      } catch (_) {
        // Ignore storage failures (private mode, blocked storage, etc.)
      }
    };

    const pickReloadReview = () => {
      if (mobileMenuReviews.length === 0) return null;
      const previousReviewId = getStoredReviewId();
      const candidates = mobileMenuReviews.length > 1
        ? mobileMenuReviews.filter((review) => `${review.id}` !== previousReviewId)
        : mobileMenuReviews;
      const nextReview = candidates[Math.floor(Math.random() * candidates.length)] || mobileMenuReviews[0];
      storeReviewId(nextReview.id);
      return nextReview;
    };

    const syncMobileMenuReviewTranslation = () => {
      if (!activeMobileMenuReview || !mobileMenuReviewText) return;
      const sourceLanguage = getReviewSourceLanguage(activeMobileMenuReview);
      const originalBody = String(activeMobileMenuReview.original_body || '').trim();
      const translatedBody = String(activeMobileMenuReview.body || '').trim();
      const country = reviewCountryName(activeMobileMenuReview);
      const hasTranslation = sourceLanguage !== ''
        && sourceLanguage.split('-')[0] !== reviewLocaleBase
        && originalBody !== '';

      mobileMenuReviewText.textContent = showOriginalMobileMenuReview && hasTranslation
        ? originalBody
        : translatedBody;

      if (!mobileMenuReviewTranslation || !mobileMenuReviewTranslationStatus || !mobileMenuReviewTranslationToggle) return;
      const hasCountry = country !== '';
      mobileMenuReviewTranslation.hidden = !hasTranslation && !hasCountry;
      if (mobileMenuReviewCountryStatus) {
        mobileMenuReviewCountryStatus.hidden = !hasCountry;
        mobileMenuReviewCountryStatus.textContent = hasCountry
          ? String(mobileMenuReview.dataset.mobileMenuReviewCountryLabel || '').replace('__COUNTRY__', country)
          : '';
      }
      if (mobileMenuReviewCountrySeparator) {
        mobileMenuReviewCountrySeparator.hidden = !hasCountry || !hasTranslation;
      }
      mobileMenuReviewTranslationStatus.hidden = !hasTranslation;
      if (mobileMenuReviewTranslationSeparator) {
        mobileMenuReviewTranslationSeparator.hidden = !hasTranslation;
      }
      mobileMenuReviewTranslationToggle.hidden = !hasTranslation;
      if (!hasTranslation) return;

      const translatedLabel = String(mobileMenuReview.dataset.mobileMenuReviewTranslatedLabel || '')
        .replace('__LANGUAGE__', reviewLanguageName(sourceLanguage));
      mobileMenuReviewTranslationStatus.textContent = translatedLabel;
      mobileMenuReviewTranslationToggle.textContent = showOriginalMobileMenuReview
        ? mobileMenuReview.dataset.mobileMenuReviewShowTranslationLabel || ''
        : mobileMenuReview.dataset.mobileMenuReviewShowOriginalLabel || '';
    };

    const safeMobileMenuProductHref = (value) => {
      try {
        const url = new URL(String(value || ''), window.location.origin);
        const internalHosts = new Set([
          window.location.hostname,
          'soundbrenner.com',
          'www.soundbrenner.com',
          'soundbrenner.cn',
          'www.soundbrenner.cn',
        ]);
        if (!internalHosts.has(url.hostname)) return '';
        const localeRoot = String(mobileMenuReview.dataset.mobileMenuLocaleRoot || '/').replace(/\/$/, '');
        const hasLocaleRoot = localeRoot && localeRoot !== '/';
        const pathname = hasLocaleRoot && url.pathname !== localeRoot && !url.pathname.startsWith(`${localeRoot}/`)
          ? `${localeRoot}${url.pathname.startsWith('/') ? '' : '/'}${url.pathname}`
          : url.pathname;
        return pathname + url.search + url.hash;
      } catch (_) {
        return '';
      }
    };

    const fetchMobileMenuReviewProductMeta = (handle) => {
      if (!mobileMenuReviewProductMetaCache.has(handle)) {
        const localeRoot = String(mobileMenuReview.dataset.mobileMenuLocaleRoot || '/').replace(/\/$/, '');
        const productJsonUrl = `${localeRoot}/products/${encodeURIComponent(handle)}.js`;
        mobileMenuReviewProductMetaCache.set(handle, fetch(productJsonUrl, { credentials: 'same-origin', signal })
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.json();
          })
          .catch(() => null));
      }
      return mobileMenuReviewProductMetaCache.get(handle);
    };

    const renderMobileMenuReviewProduct = (review) => {
      if (!mobileMenuReviewProductCard) return;
      const href = safeMobileMenuProductHref(review.product_url);
      const handle = String(review.product_handle || href.split('/').filter(Boolean).pop() || '').trim();
      if (!href || !handle) {
        mobileMenuReviewProductCard.hidden = true;
        return;
      }

      const rating = Math.max(0, Math.min(5, Number(review.product_average_rating) || 0));
      const count = Math.max(0, Number(review.product_review_count) || 0);
      const countLabel = String(mobileMenuReview.dataset.mobileMenuReviewProductReviewsLabel || '')
        .replace('__COUNT__', reviewNumberFormat.format(count));

      mobileMenuReviewProductCard.href = href;
      mobileMenuReviewProductCard.dataset.productHandle = handle;
      mobileMenuReviewProductCard.hidden = false;
      if (mobileMenuReviewProductTitle) mobileMenuReviewProductTitle.textContent = String(review.product_title || '').trim();
      if (mobileMenuReviewProductRating) mobileMenuReviewProductRating.textContent = reviewProductRatingFormat.format(rating);
      if (mobileMenuReviewProductCount) mobileMenuReviewProductCount.textContent = countLabel;
      if (mobileMenuReviewProductImage) {
        mobileMenuReviewProductImage.hidden = true;
        mobileMenuReviewProductImage.removeAttribute('src');
      }
      if (mobileMenuReviewProductMedia) mobileMenuReviewProductMedia.hidden = true;

      fetchMobileMenuReviewProductMeta(handle).then((productData) => {
        if (signal.aborted || !productData || !mobileMenuReviewProductCard.isConnected) return;
        if (mobileMenuReviewProductCard.dataset.productHandle !== handle) return;
        if (mobileMenuReviewProductTitle && productData.title) {
          mobileMenuReviewProductTitle.textContent = productData.title;
        }
        const imageSource = productData.featured_image || (productData.images || [])[0];
        if (!mobileMenuReviewProductMedia || !mobileMenuReviewProductImage || !imageSource) return;
        const normalizedImageSource = String(imageSource).startsWith('//') ? `https:${imageSource}` : imageSource;
        const imageUrl = new URL(normalizedImageSource, window.location.origin);
        imageUrl.searchParams.set('width', '128');
        const preload = new Image();
        preload.onload = () => {
          if (signal.aborted || !mobileMenuReviewProductCard.isConnected) return;
          if (mobileMenuReviewProductCard.dataset.productHandle !== handle) return;
          mobileMenuReviewProductImage.src = imageUrl.toString();
          mobileMenuReviewProductImage.hidden = false;
          mobileMenuReviewProductMedia.hidden = false;
        };
        preload.src = imageUrl.toString();
      });
    };

    const renderMobileMenuReview = (review) => {
      if (!mobileMenuReviewName || !mobileMenuReviewText || !mobileMenuReviewDate) return;
      if (!review) return;
      activeMobileMenuReview = review;
      showOriginalMobileMenuReview = false;
      mobileMenuReviewName.textContent = String(review.reviewer || '').trim();
      mobileMenuReviewDate.textContent = formatReviewDate(review.created_at);
      if (mobileMenuReviewStars) {
        const ratingLabel = String(mobileMenuReview.dataset.mobileMenuReviewRatingLabel || '')
          .replace('__RATING__', `${review.rating}`);
        mobileMenuReviewStars.setAttribute('aria-label', ratingLabel);
      }
      syncMobileMenuReviewTranslation();
      renderMobileMenuReviewProduct(review);
      mobileMenuReview.hidden = false;
    };

    const isEligibleMobileMenuReview = (review, relaxedLength = false) => {
      if (!review || review.verified !== true || Number(review.rating) !== 5) return false;
      const sourceLanguage = getReviewSourceLanguage(review);
      const isEnglishSource = sourceLanguage.split('-')[0] === 'en'
        || (sourceLanguage === '' && reviewLocaleBase === 'en');
      if (!isEnglishSource) return false;

      const reviewer = String(review.reviewer || '').trim();
      if (/^(anonymous|customer)$/i.test(reviewer)) return false;
      const englishBody = String(sourceLanguage ? review.original_body || '' : review.body || '').trim();
      const searchableReviewText = [
        review.title,
        review.body,
        review.original_title,
        review.original_body,
      ].map((value) => String(value || '')).join(' ');
      if (/\b(?:hong[\s-]+kong|china)\b/i.test(searchableReviewText)) return false;
      const minimumLength = relaxedLength ? 20 : 45;
      const maximumLength = relaxedLength ? 320 : 240;
      return reviewer.length >= 2
        && reviewer.length <= 28
        && englishBody.length >= minimumLength
        && englishBody.length <= maximumLength;
    };

    const uniqueMobileMenuReviews = (reviews) => {
      const reviewIds = new Set();
      return reviews.filter((review) => {
        const reviewId = `${review?.id || ''}`;
        if (!reviewId || reviewIds.has(reviewId)) return false;
        reviewIds.add(reviewId);
        return true;
      });
    };

    const fetchMobileMenuReviews = async (url) => {
      if (!url) return [];
      const response = await fetch(url, { credentials: 'same-origin', signal });
      if (!response.ok) throw new Error(response.status);
      const data = await response.json();
      return Array.isArray(data?.reviews) ? data.reviews : [];
    };

    const mobileMenuReviewsProxyUrl = () => {
      const source = mobileMenuReview?.dataset.mobileMenuReviewsProxyUrl;
      if (!source) return '';
      const url = new URL(source, window.location.origin);
      url.searchParams.set('scope', 'shop');
      url.searchParams.set('review_type', 'product');
      url.searchParams.set('response_version', '2');
      url.searchParams.set('locale', reviewLocale);
      url.searchParams.set('page', '1');
      url.searchParams.set('per_page', '30');
      return url.toString();
    };

    const loadMobileMenuReviews = () => {
      if (signal.aborted || !mobileMenuReview) return Promise.resolve([]);
      if (mobileMenuReviewsRequest) return mobileMenuReviewsRequest;
      mobileMenuReviewsRequest = (async () => {
        let reviewPool = [];
        try {
          const nativeSnapshot = mobileMenuReview.querySelector('[data-mobile-menu-review-snapshot]');
          const nativeReviews = nativeSnapshot ? JSON.parse(nativeSnapshot.textContent)?.reviews : null;
          reviewPool = Array.isArray(nativeReviews)
            ? nativeReviews
            : await fetchMobileMenuReviews(mobileMenuReview.dataset.mobileMenuReviewsUrl);
        } catch (_) {
          reviewPool = [];
        }

        if (signal.aborted) return [];
        let eligibleReviews = reviewPool.filter((review) => isEligibleMobileMenuReview(review));
        if (eligibleReviews.length < 2) {
          try {
            reviewPool = uniqueMobileMenuReviews([
              ...reviewPool,
              ...await fetchMobileMenuReviews(mobileMenuReviewsProxyUrl()),
            ]);
            eligibleReviews = reviewPool.filter((review) => isEligibleMobileMenuReview(review));
          } catch (_) {
            eligibleReviews = reviewPool.filter((review) => isEligibleMobileMenuReview(review));
          }
        }

        if (eligibleReviews.length === 0) {
          eligibleReviews = reviewPool.filter((review) => isEligibleMobileMenuReview(review, true));
        }
        if (signal.aborted) return [];
        mobileMenuReviews = eligibleReviews.slice(0, 12);
        renderMobileMenuReview(pickReloadReview());
        return mobileMenuReviews;
      })().catch(() => {
        mobileMenuReviews = [];
        mobileMenuReviewsRequest = null;
        return [];
      });
      return mobileMenuReviewsRequest;
    };

    const scheduleMobileMenuReviewPreload = () => {
      if (signal.aborted || !mobileMenuReview || isDesktopViewport()) return;
      const preload = () => {
        if (!signal.aborted && !isDesktopViewport()) loadMobileMenuReviews();
      };
      if (typeof window.requestIdleCallback === 'function') {
        const idleId = window.requestIdleCallback(preload);
        onAbort(() => window.cancelIdleCallback(idleId));
      } else {
        const timerId = window.setTimeout(preload, 1000);
        onAbort(() => window.clearTimeout(timerId));
      }
    };

    if (document.readyState === 'complete') scheduleMobileMenuReviewPreload();
    else addRuntimeEventListener(window, 'load', scheduleMobileMenuReviewPreload, { once: true });

    const clearBodyFixedScrollLockStyles = () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
    };

    /* Safari cancels in-flight momentum whenever the scroll position is set
       programmatically (same trick as the signup popup) - pin briefly on
       gentle-lock entry so momentum from before the open cannot scroll the
       still-scrollable page behind the overlay. */
    let gentleScrollPinFrame = 0;
    const stopGentleScrollPin = () => {
      if (!gentleScrollPinFrame) return;
      window.cancelAnimationFrame(gentleScrollPinFrame);
      gentleScrollPinFrame = 0;
    };
    const startGentleScrollPin = (pinnedY) => {
      stopGentleScrollPin();
      const pinUntil = performance.now() + 700;
      const pin = () => {
        gentleScrollPinFrame = 0;
        if (pageScrollLockMode !== 'gentle') return;
        if ((window.scrollY || 0) !== pinnedY) window.scrollTo(0, pinnedY);
        if (performance.now() < pinUntil) {
          gentleScrollPinFrame = window.requestAnimationFrame(pin);
        }
      };
      pin();
    };

    const releasePageScrollLock = ({ restoreScroll = true } = {}) => {
      stopGentleScrollPin();
      if (document.body.dataset.sbScrollLocked !== 'true') {
        pageScrollLockMode = null;
        /* Defensive: heal orphaned lock classes nobody is tracking (a locker
           that died between add and remove) - otherwise the hidden page
           scrollbar persists until reload. */
        document.documentElement.classList.remove('sb-scroll-locked');
        document.body.classList.remove('sb-scroll-locked');
        return;
      }

      const previousLockMode = pageScrollLockMode;
      const notifyScrollLockReleased = () => {
        document.dispatchEvent(
          new CustomEvent('sb:page-scroll-lock:released', {
            detail: { mode: previousLockMode },
          })
        );
      };
      document.documentElement.classList.remove('sb-scroll-locked');
      document.body.classList.remove('sb-scroll-locked');
      document.documentElement.style.overflow = '';
      clearBodyFixedScrollLockStyles();
      delete document.body.dataset.sbScrollLocked;
      pageScrollLockMode = null;

      if (restoreScroll && previousLockMode === 'fixed') {
        setStickyLastY(pageScrollLockY);
        window.scrollTo(0, pageScrollLockY);
        notifyScrollLockReleased();
        return;
      }

      setStickyLastY(window.scrollY || window.pageYOffset || 0);
      notifyScrollLockReleased();
    };

    const getPageScrollLockMode = () => {
      if (document.documentElement.classList.contains('sb-customer-privacy-open')) {
        return isDesktopViewport() ? 'overflow' : 'fixed';
      }

      if (isMobileMenuOpen()) return 'fixed';

      const searchShortcutOpen = document.documentElement.classList.contains('sb-search-shortcut-open');
      if (searchShortcutOpen) return 'fixed';

      /* These panels are anchored to sticky-header geometry. A fixed-body
         lock preserves that rendered position and, unlike root overflow,
         reliably blocks desktop Safari wheel scrolling. */
      const desktopHeaderOverlayOpen = isDesktopViewport()
        && document.querySelector(
          '.header.is-primary-open, .header.is-primary-closing, '
            + 'dropdown-localization-component[data-open="true"], '
            + '.header__localization-panel.is-closing'
        );
      if (desktopHeaderOverlayOpen) return 'fixed';

      const mobileBlogFilterOpen = isMobileViewport()
        && document.querySelector('[data-sb-blog-filter-drawer-container].menu-open');
      if (mobileBlogFilterOpen) return 'fixed';

      const mobileManualChapterDrawerOpen = isMobileViewport()
        && document.querySelector('[data-manual-chapter-dropdown][data-open="true"]');
      if (mobileManualChapterDrawerOpen) return 'fixed';

      const cartDrawerElement = document.querySelector('[data-cart-drawer]');
      const cartOpen = Boolean(
        cartDrawerElement && !cartDrawerElement.hasAttribute('hidden')
      );

      /* 'fixed' on mobile matches the pre-nav-refactor build exactly - under
         the sampled-strip chrome model (no viewport-fit=cover) the lock mode
         does not affect the iOS 26 tint, and fixed is the construction the
         clean reference build used. */
      if (cartOpen) return isDesktopViewport() ? 'overflow' : 'fixed';

      /* The signup popup hides the scrollbar but must keep the document
         scrollable in layout (Safari browser-bar reasons - see the lock
         comment in sb-signup-popup.js): classes only, no overflow or
         fixed-body styles. Lowest precedence - any real drawer above wins. */
      if (document.documentElement.classList.contains('sb-signup-popup-open')) return 'gentle';

      return null;
    };

    const syncPageScrollLock = () => {
      const nextLockMode = getPageScrollLockMode();
      if (!nextLockMode) {
        releasePageScrollLock();
        return;
      }

      if (document.body.dataset.sbScrollLocked === 'true' && pageScrollLockMode === nextLockMode) return;
      if (document.body.dataset.sbScrollLocked === 'true') {
        /* Leaving 'fixed' for a mode that doesn't fix the body must restore
           the scroll position, or the unfixed page lands at the top. */
        releasePageScrollLock({ restoreScroll: pageScrollLockMode === 'fixed' && nextLockMode !== 'fixed' });
      }

      pageScrollLockY = window.scrollY || window.pageYOffset || 0;
      setStickyLastY(pageScrollLockY);
      document.documentElement.classList.add('sb-scroll-locked');
      document.body.classList.add('sb-scroll-locked');
      document.documentElement.style.overflow = nextLockMode === 'gentle' ? '' : 'hidden';

      if (nextLockMode === 'fixed') {
        document.body.style.position = 'fixed';
        document.body.style.top = `-${pageScrollLockY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      } else {
        clearBodyFixedScrollLockStyles();
      }

      document.body.dataset.sbScrollLocked = 'true';
      pageScrollLockMode = nextLockMode;
      if (nextLockMode === 'gentle') startGentleScrollPin(pageScrollLockY);
    };

    shared.syncPageScrollLock = syncPageScrollLock;

    const openMobileMenu = () => {
      if (!mobileMenuDrawer || !mobileMenuToggle || isDesktopViewport()) return;
      loadMobileMenuReviews();
      mobileMenuToggle.setAttribute('aria-expanded', 'true');
      scheduleMobileMenuPreload();
      mobileMenuDrawer.inert = false;
      mobileMenuDrawer.classList.add('menu-open');
      window.requestAnimationFrame(updateMobileMenuTrustpilotLayout);
      document.body.classList.add('is-mobile-menu-open');
      syncPageScrollLock();
      (mobileMenuPanel?.querySelector('[data-mobile-menu-close]') || mobileMenuPanel)?.focus({ preventScroll: true });
    };

    const closeMobileMenu = ({ preserveHeaderState = false } = {}) => {
      if (!mobileMenuDrawer || !mobileMenuToggle) return;
      const wasMobileMenuOpen = isMobileMenuOpen();
      const restoreFocus = wasMobileMenuOpen && mobileMenuDrawer.contains(document.activeElement) && !isDesktopViewport();
      mobileMenuDrawer.classList.remove('menu-open');
      mobileMenuToggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus) mobileMenuToggle.focus({ preventScroll: true });
      mobileMenuDrawer.inert = true;

      closeAllMobileAccordions();
      document.body.classList.remove('is-mobile-menu-open');
      syncPageScrollLock();
      if (wasMobileMenuOpen && typeof shared.syncStickyState === 'function') {
        if (preserveHeaderState) shared.syncStickyState();
        else shared.syncStickyState({ force: true });
      }
    };

    shared.closeMobileMenu = closeMobileMenu;

    if (mobileMenuReviewTranslationToggle) {
      addRuntimeEventListener(mobileMenuReviewTranslationToggle, 'click', () => {
        showOriginalMobileMenuReview = !showOriginalMobileMenuReview;
        syncMobileMenuReviewTranslation();
      });
    }

    if (mobileMenuDrawer && mobileMenuToggle) {
      addRuntimeEventListener(mobileMenuToggle, 'click', (event) => {
        event.preventDefault();
        if (isMobileMenuOpen()) closeMobileMenu();
        else openMobileMenu();
      });

      mobileMenuCloseControls.forEach((control) => {
        addRuntimeEventListener(control, 'click', () => closeMobileMenu());
      });

      mobileMenuDrawer.querySelectorAll('.menu-drawer__navigation a').forEach((link) => {
        addRuntimeEventListener(link, 'click', () => closeMobileMenu());
      });

      addRuntimeEventListener(mobileMenuDrawer, 'keyup', (event) => {
        if (event.key !== 'Escape') return;
        closeMobileMenu();
      });

      addRuntimeEventListener(window, 'resize', () => {
        if (isDesktopViewport()) {
          closeMobileMenu({ preserveHeaderState: true });
          if (typeof shared.schedulePrimaryMenuPreload === 'function') {
            shared.schedulePrimaryMenuPreload();
          }
          return;
        }

        scheduleMobileMenuPreload();
        window.requestAnimationFrame(updateMobileMenuTrustpilotLayout);
      }, { passive: true });

      scheduleMobileMenuPreload();
      window.requestAnimationFrame(updateMobileMenuTrustpilotLayout);
    }

    addRuntimeEventListener(document, 'keydown', (event) => {
      if (event.key !== 'Tab' || !isMobileMenuOpen() || !mobileMenuPanel) return;
      const focusScope = mobileMenuPanel.querySelector('drawer-localization-component.menu-open [data-localization-ref="drawerPage"]') || mobileMenuPanel;
      const focusables = [...focusScope.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]')]
        .filter((element) => element.tabIndex >= 0 && !element.disabled && !element.closest('[inert]')
          && element.getClientRects().length && getComputedStyle(element).visibility === 'visible');
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (!first) {
        event.preventDefault();
        mobileMenuPanel.focus({ preventScroll: true });
      } else if (!focusScope.contains(document.activeElement)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({ preventScroll: true });
      } else if (event.shiftKey && (document.activeElement === first || document.activeElement === mobileMenuPanel)) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    });

    addRuntimeEventListener(document, 'sb:cart-drawer:state-change', syncPageScrollLock);
    addRuntimeEventListener(document, 'sb:header-search-shortcut:toggle', syncPageScrollLock);
    addRuntimeEventListener(document, 'sb:header-localization:settled', syncPageScrollLock);
    addRuntimeEventListener(document, 'sb:blog-filter:state-change', syncPageScrollLock);
    addRuntimeEventListener(document, 'sb:manual-chapter-drawer:state-change', syncPageScrollLock);
    addRuntimeEventListener(document, 'sb:customer-privacy:state-change', syncPageScrollLock);
    addRuntimeEventListener(document, 'sb:signup-popup:state-change', syncPageScrollLock);
    /* Unconditional startup sync: adopts any surface that opened before this
       module initialized (the signup popup can open pre-init - it is the LCP
       for eligible visitors) and heals orphaned lock classes from a prior
       locker via the defensive release path. */
    syncPageScrollLock();

    onAbort(() => {
      if (isMobileMenuOpen()) {
        mobileMenuDrawer?.classList.remove('menu-open');
        mobileMenuDrawer.inert = true;
        mobileMenuToggle?.setAttribute('aria-expanded', 'false');
        closeAllMobileAccordions();
        document.body.classList.remove('is-mobile-menu-open');
      }
      releasePageScrollLock({ restoreScroll: false });
    });
  });
})();
